import * as Sentry from "@sentry/react";

import { isStage } from "utils/misc/getBuildEnvironment";
import { isTestRunning } from "utils/misc/isTestRunning";
import { getAppDataRegion } from "utils/region";

/**
 * Sentry runs alongside Honeybadger while we evaluate the two error trackers.
 * Errors only for now (no performance tracing, no session replay) to keep the
 * comparison apples-to-apples and quota usage low.
 *
 * Sentry is disabled when REACT_APP_SENTRY_DSN is unset, when running on
 * localhost, and during automated test runs (mirroring the Honeybadger setup).
 */
const initSentry = (): void => {
  const dsn = process.env.REACT_APP_SENTRY_DSN;

  if (!dsn || isTestRunning() || window.location.hostname.includes("localhost")) {
    return;
  }

  Sentry.init({
    dsn,
    environment: isStage() ? "staging" : "production",
    release: `${process.env.REACT_APP_VERSION}-${getAppDataRegion()}`,
    integrations: [
      // Honeybadger is configured with enableUnhandledRejection: false, so
      // disable rejection capturing here too to keep the trackers comparable.
      Sentry.globalHandlersIntegration({ onerror: true, onunhandledrejection: false }),
    ],
    // Matches the Honeybadger beforeNotify filter.
    ignoreErrors: [/ResizeObserver loop/],
    initialScope: { tags: { market: getAppDataRegion() } },
    sendDefaultPii: false,
  });
};

initSentry();
